import React, { useState } from 'react';
import BigDataHome from './BigDataHome';
import DatasetWorkspace from './DatasetWorkspace';
import { BigDataDataset } from '../../services/BigDataDatasetService';
import { debugLog } from '../../utils/debug-logger';

const BigDataAnalytics: React.FC = () => {
  const [selectedDataset, setSelectedDataset] = useState<{
    id: string;
    data: BigDataDataset;
  } | null>(null);

  const handleSelectDataset = (datasetId: string, dataset: BigDataDataset) => {
    debugLog('[🎯 BigDataAnalytics] handleSelectDataset - Dataset selected!');
    debugLog('[📦 BigDataAnalytics] Dataset ID:', datasetId);
    debugLog('[📊 BigDataAnalytics] Dataset data:', {
      id: dataset.id,
      file_name: dataset.file_name,
      job_id: dataset.job_id,
      status: dataset.status,
      row_count: dataset.row_count,
      column_count: dataset.column_count,
      hasColumns: !!dataset.columns,
      columnsType: typeof dataset.columns,
      columnsIsArray: Array.isArray(dataset.columns),
      columnsLength: dataset.columns?.length
    });
    debugLog('[🔍 BigDataAnalytics] RAW dataset.columns:', dataset.columns);
    
    setSelectedDataset({ id: datasetId, data: dataset });
    debugLog('[✅ BigDataAnalytics] Selected dataset set in state');
  };

  const handleBack = () => {
    setSelectedDataset(null);
  };

  const handleUpdate = () => {
    // Refresh dataset data if needed
    // For now, just keep it simple
  };

  return (
    <div className="min-h-screen">
      {selectedDataset ? (
        <DatasetWorkspace
          dataset={selectedDataset.data}
          onBack={handleBack}
          onUpdate={handleUpdate}
        />
      ) : (
        <BigDataHome onSelectDataset={handleSelectDataset} />
      )}
    </div>
  );
};

export default BigDataAnalytics;



